import { z } from 'zod';

export const documentTypeColumnDefinitionFieldSchema = z.object({
  documentTypeCode: z.string(),
  documentTypeId: z.string(),
  fieldName: z.string(),
});

export const getDocumentTypeColumnDefinitionFieldsSchema = z.array(
  documentTypeColumnDefinitionFieldSchema
);
